module.exports = __webpack_public_path__ + "media/images/banner_invitation-e51eb4039441ed05426ce8b2b6b65c86.png";